export const INQUIRY_NOT_ACCESSIBLE_ERROR = 'api.covestro.c4cticketinquiry.error.notaccessible';
